import React, {PropsWithChildren} from "react";

/**
 * A small utility which provides common styles to images in the appointment tile.
 */
const ImageFrame = ({children}: PropsWithChildren<unknown>) => {
  return <div className="p-2 flex-shrink-0">{children}</div>;
};

export default React.memo(ImageFrame);
